export default {
  en: {
    Vocabulary: "Vocabulary",
    Enumeration: "Enumeration",
    Term: "Term",
    Description: "Description",
    EnumerationExtensibility: "This enumeration can be extended with new, proprietary terms.\nThe new terms must start with the substring 'ext:'."
  },
  es: {
    Vocabulary: "Vocabulario",
    Enumeration: "Enumeración",
    Term: "Término",
    Description: "Descripción",
    EnumerationExtensibility: "Esta enumeración se puede extender con términos nuevos i/o propietarios.\nLos términos nuevos deben empezar con la subcadena 'ext:'."
  },
  ca: {
    Vocabulary: "Vocabulari",
    Enumeration: "Enumeració",
    Term: "Terme",
    Description: "Descripció",
    EnumerationExtensibility: "Aquesta enumeració es pot ampliar amb termes nous i/o propietari.\nEls nous termes han de començar per la subcadena 'ext:'."
  }
};
